<template>
  <v-card tile light>
    <v-toolbar
      flat
      max-height="56"
      color="grey lighten-4"
    >
      <v-btn
        icon
        color="primary"
        @click.stop="close()"
      >
        <v-icon v-text="icons.close" />
      </v-btn>
      <v-spacer />
      <v-toolbar-title>{{ __('orderDiscount') }}</v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <h-discounts-list
        :disabled="disabled"
        :discounts="discounts"
        :selected="selected"
        @apply="apply"
        @cancel="cancel"
      />
    </v-card-text>
  </v-card>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HDiscountsList from './List'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HDiscountsList,
    },

    computed: {
      order () {
        return this.$store.state.orders.current
      },
      disabled () {
        return this.$store.state.orders.dialogs.locked
      },
      discounts () {
        return this.$store.getters['rummage/orderDiscounts']
      },
      selected () {
        return this.order.discount
      },
    },

    methods: {
      apply (discount) {
        // Cancel the discount is not necessary but doing so animates the
        // discount display and enhances the user experience.
        this.$store.commit('orders/cancelDiscount')
        this.$log(`Updated order discount: ${discount.id} (${discount.discount ?? 0}${!! discount.isPercentage ? '%' : ''})`, 'Order', this.order.id)
        setTimeout(() => this.$store.commit('orders/applyDiscount', discount), 250)
        this.close()
      },
      cancel () {
        this.$log('Updated order discount: NULL (0)', 'Order', this.order.id)
        setTimeout(() => this.$store.commit('orders/cancelDiscount'), 250)
        this.close()
      },
      close () {
        this.$store.dispatch('orders/dialogs/close')
      },
    },
  }
</script>
